import Icon from '../components/Icon';

const Location = Icon(
  'location',
  <>
    <path
      fillRule="evenodd"
      d="M20.119 2.751a1.5 1.5 0 0 0-.828.047h-.002L3.423 8.292H3.42c-1.385.476-1.32 2.425.05 2.85l7.174 2.213.004.002 2.21 7.171v.002c.426 1.37 2.374 1.435 2.85.05v-.002l5.492-15.866.001-.002a1.5 1.5 0 0 0-1.083-1.958m-9.044 9.166L3.916 9.71l-.002-.001 15.869-5.493.003-.001-.001.003-5.493 15.87v-.003l-2.21-7.173a1.45 1.45 0 0 0-1.007-.994"
      clipRule="evenodd"
    />
  </>
);

export default Location;
